import pushGTMEvent from '@helpers/analyticsHelpers/pushGTMEvent';

const trackPlaceOrderClick = () => {
  pushGTMEvent({
    event: 'Track',
    category: 'checkout',
    action: 'continue_to_complete_payment',
    label: '',
    value: 0,
  });
};
export default trackPlaceOrderClick;
